import React from 'react';
import PropTypes from 'prop-types';

import { Wrapper, Message } from './messsage-banner.styles';

const MessageBanner = ({
  color,
  message,
}) => message ? (
  <Wrapper
    backgroundColor={color}
    showOverlay={false}
    variant='full'>
    <Message source={message} />
  </Wrapper>
) : null;

MessageBanner.propTypes = {
  color: PropTypes.string,
  message: PropTypes.string,
};

MessageBanner.defaultProps = {
  color: 'blue',
  message: null,
};

export default MessageBanner;
